import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.users');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.users/view.scss */
/* src/app/page.admin.users/view.scss: no such file or directory */`],
})
export class PageAdminUsersComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public searchText: string = '';
    public roleFilter: string = '';
    public pages: number[] = [];
    public totalPages: number = 0;

    public showEditor: boolean = false;
    public editItem: any = {};
    public showPasswordReset: boolean = false;
    public resetTarget: any = {};
    public newPassword: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call("search", {
            page: this.page, dump: this.dump,
            text: this.searchText, role: this.roleFilter
        });
        if (code === 200) {
            this.items = data.rows;
            this.total = data.total;
            this.totalPages = Math.ceil(this.total / this.dump);
            this.pages = [];
            let start = Math.max(1, this.page - 2);
            let end = Math.min(this.totalPages, start + 4);
            start = Math.max(1, end - 4);
            for (let i = start; i <= end; i++) this.pages.push(i);
        }
        await this.service.render();
    }

    public openNew() {
        this.editItem = { email: '', password: '', name: '', role: 'doctor', specialty: '', license_no: '', phone: '' };
        this.showEditor = true;
    }

    public openEdit(item: any) {
        this.editItem = { ...item };
        this.showEditor = true;
    }

    public closeEditor() {
        this.showEditor = false;
        this.editItem = {};
    }

    public async saveItem() {
        if (!this.editItem.email || !this.editItem.name) {
            await this.service.modal.show({ title: '알림', message: '이메일과 이름은 필수입니다.', action: '확인' });
            return;
        }
        if (!this.editItem.id && !this.editItem.password) {
            await this.service.modal.show({ title: '알림', message: '비밀번호는 필수입니다.', action: '확인' });
            return;
        }
        const sendData = { ...this.editItem };
        if (sendData.password) {
            const crypto = this.service.crypto;
            sendData.password = await crypto.sha256(sendData.password);
        }
        const { code } = await wiz.call("save", { data: JSON.stringify(sendData) });
        if (code === 200) {
            this.closeEditor();
            await this.load(this.page);
        }
    }

    public async toggleActive(item: any, event: any) {
        event.stopPropagation();
        const newState = !item.is_active;
        const msg = newState ? `'${item.name}' 계정을 활성화하시겠습니까?` : `'${item.name}' 계정을 비활성화하시겠습니까?`;
        const res = await this.service.modal.show({ title: '확인', message: msg, action: '확인' });
        if (res) {
            await wiz.call("toggle_active", { id: item.id, is_active: newState });
            await this.load(this.page);
        }
    }

    public openPasswordReset(item: any, event: any) {
        event.stopPropagation();
        this.resetTarget = item;
        this.newPassword = '';
        this.showPasswordReset = true;
    }

    public async doResetPassword() {
        if (!this.newPassword || this.newPassword.length < 4) {
            await this.service.modal.show({ title: '알림', message: '비밀번호는 4자 이상이어야 합니다.', action: '확인' });
            return;
        }
        const crypto = this.service.crypto;
        const hashed = await crypto.sha256(this.newPassword);
        const { code } = await wiz.call("reset_password", { id: this.resetTarget.id, password: hashed });
        if (code === 200) {
            this.showPasswordReset = false;
            await this.service.modal.show({ title: '완료', message: '비밀번호가 재설정되었습니다.', action: '확인' });
        }
    }

    public roleLabel(role: string) {
        const map: any = { admin: '관리자', doctor: '의사' };
        return map[role] || role;
    }
}

export default PageAdminUsersComponent;